module.exports = "<!--The content below is only a placeholder and can be replaced.-->\n\n<head-menu></head-menu>\n<router-outlet></router-outlet>\n<!-- <home></home> -->\n<footer-html></footer-html>\n<popup-inquiry></popup-inquiry>\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main